<template>
  <div class="">
    <draggable
      v-if="questions.length > 0"
      :list="questions"
      tag="div"
      disabled="dragging"
    >
      <div
        class="mt-4 questions-background"
        v-for="(question, questionIndex) in questions"
        :key="questionIndex"
        style="padding-left: 25px;"
      >
        <ul>
          <li class="">
            <div class="question-info">
              <div class="exams-question">
                <p class="mr-2">คำถาม:</p>
                <div class="text-truncate exams-question-markdown">
                  {{ question.title }}
                </div>
              </div>
              <div class="exams-question-buttons d-flex align-items-center">

                <p @click="toggleCollapse(question.id)" class="pointer">
                  <b-icon
                    :icon="getCollapseIcon(question.id)"
                    scale="2"
                  ></b-icon>
                </p>
              </div>
            </div>
            <b-collapse
              visible
              :id="question.id"
              v-model="collapsedQuestions[question.id]"
            >
              <b-row>
                <b-col :cols="question.type === 'PASSAGE' || isBundle ? 12 : 11">
                  <div class="show-edit-question mb-3 mt-4">
                    <h5
                      v-if="question.type != 'PASSAGE'"
                      class="font-weight-bold my-auto"
                    >
                      คำถาม
                    </h5>
                    <h5 v-else class="font-weight-bold my-auto">บทความ</h5>
                  </div>
                  <div class="edit-question">
                    <mark-down class="mr-2 mb-0 question-markdown" :message="question.title"></mark-down>
                  </div>
                </b-col>
                <b-col cols="1" v-if="!(question.type === 'PASSAGE' || isBundle)">
                  <div class="show-edit-question mb-2 mt-4">
                    <h6 class="mt-2 mb-1">คะแนน</h6>
                  </div>
                  <div>
                    {{ question.score }}
                  </div>
                </b-col>
              </b-row>

              <hr class="my-3" />
              <PreviewPassageAndBundleQuestion
                v-if="question.type == 'PASSAGE' || question.type == 'BUNDLE'"
                :section="section"
                :question="question"
                :questionIndex="questionIndex"
                :sectionIndex="sectionIndex"
                :isBundle="question.type === 'BUNDLE' ? true : false"
                :key="componentKey"
              />

              <PreviewMultiChoiceQuestion
                v-if="question.type == 'MULTIPLE_CHOICE'"
                :question="question"
                :choices="question._choices"
                :isSubQuestion="isSubQuestion"
                :mainQuestionId="mainQuestionId"
                :key="componentKey"
              />

              <PreviewFillBlankQuestion
                v-if="question.type == 'FILL_BLANK'"
                :questionId="question.id"
                :questionIndex="questionIndex"
                :sectionIndex="sectionIndex"
                :isSubQuestion="isSubQuestion"
                :mainQuestionId="mainQuestionId"
                :key="componentKey"
              />

              <hr class="my-3" v-if="question.type != 'PASSAGE' && question.type != 'BUNDLE'" />

              <div v-if="question.type != 'PASSAGE' && question.type != 'BUNDLE'">
                <div class="desc-answer mb-2">
                  <div>
                    <span class="font-weight-bolder">
                      คำอธิบายเฉลย
                    </span>
                  </div>
                  
                  <p
                    v-b-toggle="question.id + questionIndex"
                    @click="onShowAnswerSolution(question.id)"
                  >
                    <b-icon class="down" icon="chevron-down" scale="2"></b-icon>
                    <b-icon class="up" icon=" chevron-up" scale="2"></b-icon>
                  </p>
                </div>
                <b-collapse
                  :id="question.id + questionIndex"
                  accordion="answer-desc"
                >
                  <div v-if="solutions[question.id]">
                    <mark-down :message="solutions[question.id]"></mark-down>
                  </div>
                  <div v-else-if="!isSolutionLoading">
                    <p class="no-solution">ไม่มีคำอธิบาย</p>   
                  </div>
                  <div v-else class="text-center my-3">
                    <b-spinner
                      variant="primary"
                      label="Spinning"
                      style="width: 2rem; height: 2rem;"
                    ></b-spinner>
                    <div>
                      กรุณารอคำอธิบายเฉลยแสดงผล
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-collapse>
          </li>
        </ul>
      </div>
    </draggable>
    <div v-else>
      <p class="no-solution">Section นี้ไม่มีคำถาม</p>   
    </div>
    <pre></pre>
  </div>
</template>

<script>
import "@toast-ui/editor/dist/toastui-editor.css";
import draggable from "csq-vue-multi-draggable";
import { mapActions, mapGetters } from "vuex";
import PreviewPassageAndBundleQuestion from "./PreviewPassageAndBundleQuestion.vue";
import PreviewMultiChoiceQuestion from "./PreviewMultiChoiceQuestion.vue";
import PreviewFillBlankQuestion from "./PreviewFillBlankQuestion.vue";
import MarkDown from "@/components/shared/Markdown.vue";

export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      examId: this.$route.params.quizExamId,
      componentKey: 0,
      isSolutionLoading: false
    };
  },
  props: {
    questions: Array,
    section: Object,
    sectionIndex: Number,

    //subQuestion
    isSubQuestion: {
      type: Boolean,
      default: false,
    },
    mainQuestionId: {
      type: String,
      default: "",
    },
    mainQuestionIndex: {
      type: Number,
      default: 0,
    },
    isBundle: Boolean,
  },

  components: {
    draggable,
    PreviewPassageAndBundleQuestion,
    PreviewMultiChoiceQuestion,
    PreviewFillBlankQuestion,
    MarkDown
  },

  mounted() {
    this.questions.forEach((question) => {
      this.addCollapsedQuestions(question.id);
    });
  },

  computed: {
    ...mapGetters("ExamBuilder", ["exam", "answer", "allAnswer", "collapsedQuestions", "hasAnswers", "solutions", ]),
  },

  methods: {
    ...mapActions("ExamBuilder", [
      "findExamsbyId",
      "toggleCollapsedQuestions",
      "addCollapsedQuestions",
      "fetchQuestionAnswer",
      "fetchQuestionAllAnswer",
      "setSolution",
      "setNoSolution",
    ]),

    toggleCollapse(questionId) {
      this.toggleCollapsedQuestions(questionId)
    },

    getCollapseIcon(questionId) {
      return this.collapsedQuestions[questionId]
        ? "chevron-up"
        : "chevron-down";
    },

    async onShowAnswerSolution(questionId) {
      try {
        if (!this.hasAnswers[questionId]) {
          this.setNoSolution(questionId)
          return;
        }
        this.isSolutionLoading = true;

        if (!this.isSubQuestion) {
          await this.fetchQuestionAnswer(questionId);
          this.setSolution({ 
            questionId: questionId, 
            solution : this.answer.solution 
          })
        } else {
          await this.fetchQuestionAnswer(this.mainQuestionId);

          for (const subQuestion of this.answer.subQuestions) {
            if (questionId === subQuestion.id) {
              this.setSolution({ 
                questionId: questionId, 
                solution : subQuestion.solution 
              })
              break;
            }
          }
        }
        this.isSolutionLoading = false;
      } catch (error) {
        console.log(error);
        this.isSolutionLoading = false;
      }
    }
  },
};
</script>

<style lang="css">
.question-markdown img{
  width: 40%;
  max-width: 40%;
  word-break: break-word;
}
</style>

<style lang="css" scope>
.no-solution {
    color: orange;
    width: 100%;
    padding: 10px;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 5px;
}

.icon-middle {
  vertical-align: middle;
}

@media (min-width: 1000px) {
  .edit-question-modal .modal-dialog {
    max-width: 1140px !important;
  }
}

.handle {
  cursor: move;
}
.questions-background {
  padding: 20px;
  background: #ffffff 0% 0%;
  border: 1px solid #d3d9de;
  border-radius: 4px;
  opacity: 1;
}

.question-text {
  width: 100% !important;
  padding: 0 20px 0 0;
}

.question-info,
.desc-answer {
  display: flex;
  justify-content: space-between;
}

.edit-question {
  display: flex;
}

.exams-question {
  display: flex;
  font-weight: 700;
  font-size: 22px;
}

.exams-question-markdown {
  max-width: 50vw;
}

.choice-list {
  border-radius: 5px;
  box-shadow: 1px 1px 5px #d5d5d5;
  padding: 5px;
  margin: 10px 0;
  font-size: 14px;
}

.choice-list-selected {
  border-radius: 5px;
  border: #28A745 1px solid;
  background-color: #D4EDDA;
  box-shadow: 1px 1px 5px #d5d5d5;
  padding: 5px;
  margin: 10px 0;
  font-size: 14px;
}

.choice-text {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.choice-text-info {
  display: flex;
  align-items: center;
}

.question-list {
  width: 100%;
  padding: 5px 15px 5px 0;
}

.show-edit-question {
  display: flex;
}

.edit-question table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 12px 0 14px;
  color: #222;
  width: auto;
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.edit-question table th {
  background-color: #555;
  font-weight: 300;
  color: #fff;
  padding-top: 6px;
}

.edit-question table th,
.edit-question table td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 14px 5px 12px;
  height: 32px;
}

.not-collapsed .up,
.down {
  display: block !important;
}
.collapsed .up,
.not-collapsed .down {
  display: none !important;
}
ul {
  padding-left: 0px;
  list-style: none;
  width: 100%;
}
.disabled-div {
  pointer-events: none;
  opacity: 0.4;
}
</style>
